/*
 * Period Messages
 *
 * This contains all the text for the Period component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  timeslots: {
    id: 'app.components.Period.timeslots',
    defaultMessage: 'Time Slots',
  },
  helptext: {
    id: 'app.components.Period.helptext',
    defaultMessage: 'Drag or click in the calendar to create time slots',
  },
  chromebookTitle: {
    id: 'app.components.Period.chromebookTitle',
    defaultMessage: 'Dragging on a Chromebook',
  },
  chromebookMessage: {
    id: 'app.components.Period.chromebookMessage',
    defaultMessage: 'Using one finger, click and hold the start slot. Drag with a second finger to the end slot, then release both fingers.',
  },
  requiredSlots: {
    id: 'app.components.Period.requiredSlots',
    defaultMessage: 'required time slots created',
  },
  noSlots: {
    id: 'app.components.Period.noSlots',
    defaultMessage: 'There are no time slots yet',
  },
  meetingsAssigned: {
    id: 'app.components.Period.meetingsAssigned',
    defaultMessage: 'meetings assigned',
  },
  slotsAvailable: {
    id: 'app.components.Period.slotsAvailable',
    defaultMessage: 'time slots available',
  },
  viewUnplanned: {
    id: 'app.components.Period.viewUnplanned',
    defaultMessage: 'View unplanned meetings',
  },
  unplannedMeetings: {
    id: 'app.components.Period.unplannedMeetings',
    defaultMessage: 'Unplanned Meetings',
  },
  canSkip: {
    id: 'app.components.Period.canSkip',
    defaultMessage: 'Assign parents to time slots already. If you want parents to select their own time slot, you can skip this step.',
  },
  addBlock: {
    id: 'app.components.Period.addBlock',
    defaultMessage: 'Add Time Slots',
  },
  next: {
    id: 'app.common.next',
    defaultMessage: 'Next',
  },
  startTime: {
    id: 'app.components.Period.startTime',
    defaultMessage: 'Start Time',
  },
  endTime: {
    id: 'app.components.Period.endTime',
    defaultMessage: 'End Time',
  },
  slotCount: {
    id: 'app.components.Period.slotCount',
    defaultMessage: 'Number of Slots',
  },
  futureOnly: {
    id: 'app.components.Period.futureOnly',
    defaultMessage: 'You can\'t plan for the past',
  },
  noNextYear: {
    id: 'app.components.Period.noNextYear',
    defaultMessage: 'You can\'t plan parent meetings for next year before the year transition has been done',
  },
});
